/**
 * @module app.bdc.list.listCtrl
 *
 * The var names witch contain "loading" mean : is a request pending ?
 */
define(['angular', 'moment'], function(angular, moment) {


    function ListCtrl(
        $scope,
        $window,
        $location,
        $timeout,
        userNetworkService,
        orderService,
        $log,
        $filter,
        clientService,
        orderFormService,
        $rootScope,
        Notification,
        reportRoutingService,
        $uibModal,
        cpiService,
        marketService,
        userService,
        filtersService,
        commonService,
        emailService,
        orderTypeService,
        contractTypeService,
        scenarioTypeService,
        storeTypeService,
        x3IntegrationStatusService,
        authService,
        pricesService,
        unitBonusService,
        goodwillGesturesService
    ) {
        authService.updateLoginStatus(); // on verifie que le token est toujours là
        // $scope.selectActiveMenu(3);
        let self = {};
        self.reportRouting = reportRoutingService;
        self.marketService = marketService;
        self.orderTypeService = orderTypeService;
        self.contractTypeService = contractTypeService;
        self.scenarioTypeService = scenarioTypeService;
        self.storeTypeService = storeTypeService;
        self.userService = userService;
        self.commonService = commonService;
        self.x3IntegrationStatusService = x3IntegrationStatusService;
        self.userNetwork;
        self.orders = [];
        self.isMultiStores = false;
        self.limit = 50;

        // Display or not the no orders message
        self.loadingOrders = true;
        // Is other Orders to load ?
        self.isOtherOrders = true;
        self.isOtherOrdersLoading = false;

        // Specific keys used to store order ids for each specific action on an order
        self.orderToDelete;
        self.orderToSign;
        self.orderToLose;
        self.orderToSetReadyForX3Integration;

        self.isPanelOpened = false;

        /**
         * Get number of tills in order
         * @param order
         * @returns {number}
         */
        self.getOrderNbTills = (order) => {
            let nbTills = 0;
            for (let i = 0; i < order.tills.length; i++) {
                nbTills += order.tills[i].nbTills;
            }
            return nbTills;
        }

        /**
         * Update order list
         * @param {Boolean} append
         */
        function _updateOrdersList(append) {
            self.loadingOrders = true;
            orderService
                .getOrders(_filters)
                .then(function(orders) {
                    if (append) {
                        self.orders = self.orders.concat(orders);

                        if (orders.length < _filters.limit) {
                            self.isOtherOrders = false;
                        }
                    }
                    else {
                        self.orders = orders;
                    }
                })
                .catch(function(err) {
                    $log.error(err);
                    self.orders = [];
                })
                .finally(function() {
                    self.isOtherOrdersLoading = false;
                    self.loadingOrders = false;
                });
        }

        self.isOnline = function isOnline() {
            return $rootScope.online;
        };

        /**
         * Load more orders
         */
        self.loadMoreOrders = function loadMoreOrders() {
            self.isOtherOrdersLoading = true;
            _filters.offset++;
            _updateOrdersList(true);
        };

        self.selectOrder = function selectOrder(order) {
            $rootScope.orderDiscounts = orderService.updateDiscountValues(order.options);
            $rootScope.order = order;
            _goToOrderForm();
        };

        /**
         * Prepare the order to delete
         * @param  {int} id
         */
        self.prepareDelete = function prepareDelete(id) {
            self.orderToDelete = id;
            _openModalDeleteOrder();
        };

        /**
         * Delete the prepared order
         */
        function _confirmDelete() {
            var index = 0;

            for (var i = 0; i < self.orders.length; i++) {
                if (self.orders[i].id === self.orderToDelete) {
                    index = i;
                    orderService
                        .deleteOrder(self.orders[i])
                        .then(function(info) {
                            Notification.success(info);

                            // Delete the order in the displayed list
                            self.orders.splice(index, 1);
                        })
                        .catch(function(err) {
                            Notification.error(err.data);
                            $log.error(err);
                        });
                }
            }
        }

        /**
         * Prepare the order to sign
         * @param  {int} id
         */
        self.prepareSign = function prepareSign(id) {
            self.orderToSign = id;
            _ckeckBeforeSignOrder();
        };

        function _ckeckBeforeSignOrder() {
            var nbTills = 0;
            var nbCashDrawers = 0;

            for (var i = 0; i < self.orders.length; i++) {
                if (self.orders[i].id === self.orderToSign) {
                    for (var j = 0; j < self.orders[i].tills.length; j++) {
                        nbTills += self.orders[i].tills[j].nbTills;
                    }

                    for (var k = 0; k < self.orders[i].cashDrawers.length; k++) {
                        nbCashDrawers += self.orders[i].cashDrawers[k].nbCashDrawers;
                    }
                    if (self.orders[i].orderType === 'NAP' && nbTills !== nbCashDrawers) {
                        Notification.error(
                            'Vous ne pouvez pas signer. Le nombre de caisses est différent du nombre de tiroirs caisses.'
                        );
                        return;
                    }

                    if(self.orders[i].business === null){
                        Notification.error(
                            'Le bon de commande n\'est lié à aucune affaire. Veuillez l\'ouvrir et l\'enregistrer avant de le signer.'
                        );
                        return;
                    }


                    return _openModalSignOrder('lg');
                }
            }
        }

        /**
         *
         * Sign the prepared order
         * @param  {Object} data object coming from signOrder modal
         */
        function _confirmSign(data) {
            for (var i = 0; i < self.orders.length; i++) {
                if (self.orders[i].id === self.orderToSign) {
                    self.orders[i].rdvOrigin = data.rdvOrigin;
                    self.orders[i].dateSignature = moment(data.dateSignature, 'DD/MM/YYYY').format('YYYY-MM-DD');
                    self.orders[i].sponsor = data.sponsor;
                    self.orders[i].comment = data.comment;
                    self.orders[i].teteReseauMPDV = data.teteReseauMPDV;

                    orderService
                        .signOrder(self.orders[i])
                        .then(function(info) {
                            Notification.success(info);
                            // ---- Discount Notification email ---
                            if (!userService.isSalesAdmin(self.userNetwork)) {
                                // Only send the discountNotification email if the user is not a sales Admin
                                // Parse orderForm to get missing options keys
                                self.orders[i].options.forEach(function(orderOption) {
                                    var optionInfos = $rootScope.orderForm.options.find(function(formOption) {
                                        return formOption.id === orderOption.id;
                                    });
                                    orderOption.optionType = optionInfos ? optionInfos.optionType : '';
                                    orderOption.label = optionInfos ? optionInfos.label : '';
                                });

                                if (orderService.checkDiscounts(self.orders[i].options).length > 0) {
                                    var message = emailService.discountNotification(self.orders[i]);
                                    var data = {
                                        subject: message.subject,
                                        recipient: self.userNetwork.parent.mail,
                                        content: message.content
                                    };
                                    emailService
                                        .send(data)
                                        .then(function(info) {
                                            $log.info(info);
                                        })
                                        .catch(function(err) {
                                            Notification.error('Erreur email remise ' + err.data.message);
                                            $log.error(err);
                                        });
                                }
                            }
                            // -------
                        })
                        .catch(function(err) {
                            Notification.error(
                                'Erreur signature commande/préparation mail remise: ' + JSON.stringify(err.data)
                            );
                            $log.error(err);
                        });
                    break;
                }
            }
        }

        self.prepareLose = function prepareLose(id) {
            self.orderToLose = id;
            _ckeckBeforeLoseOrder()
        };

        function _ckeckBeforeLoseOrder() {
            for (let i = 0; i < self.orders.length; i++) {
                if (self.orders[i].id === self.orderToLose) {
                   if(self.orders[i].business === null){
                        Notification.error(
                            'Le bon de commande n\'est lié à aucune affaire. Veuillez l\'ouvrir et l\'enregistrer.'
                        );
                        return;
                    }


                    return _openModalLoseOrder('lg');
                }
            }
        }

        self.prepareAbandoned = function (id) {
            self.orderToAbandoned = id;
            _ckeckBeforeAbandonedOrder()
        };

        function _ckeckBeforeAbandonedOrder() {
            for (let i = 0; i < self.orders.length; i++) {
                if (self.orders[i].id === self.orderToAbandoned) {
                    if(self.orders[i].business === null){
                        Notification.error(
                            'Le bon de commande n\'est lié à aucune affaire. Veuillez l\'ouvrir et l\'enregistrer.'
                        );
                        return;
                    }


                    return _openModalAbandonedOrder('lg');
                }
            }
        }

        self.prepareRollbackDateCreated = function (id) {
            self.orderToRollback = id;
            _ckeckBeforeRollbackDateCreated()
        };

        function _ckeckBeforeRollbackDateCreated() {
            for (let i = 0; i < self.orders.length; i++) {
                if (self.orders[i].id === self.orderToRollback) {
                    if(self.orders[i].replaceOrderId === null){
                        Notification.error(
                            'Le devis n\'est lié à aucun autre.'
                        );
                        return;
                    }

                    return _openModalRollbackDateCreated('lg');
                }
            }
        }

        self.prepareSetReadyForX3Integration = function prepareSetReadyForX3Integration(order) {
            self.orderToSetReadyForX3Integration = order.id;
            _openModalSetOrderReadyForX3Integration(order);
        };

        self.duplicateOrder = function duplicateOrder(order) {
            orderService
                .duplicate(order)
                .then(function(duplicateOrder) {
                    Notification.success(
                        "Le bon de commande a été dupliqué, le nouveau bon de commande possède l'id: " +
                            duplicateOrder.id
                    );
                    self.orders.splice(0, 0, duplicateOrder);
                })
                .catch(function(err) {
                    $log.error(err);
                    Notification.error('Une erreur est survenue ' + (err.data ? ': ' + err.data : ''));
                });
        };

        /**
         * Is the app in online mode ?
         * @return {Boolean}
         */
        self.isOnline = function isOnline() {
            return $rootScope.online;
        };

        self.isClickable = function isClickable(order) {
            return (order.id !== null && order.isSynchronized && self.isOnline()) || !self.isOnline();
        };

        self.isEXTUser = function isEXTUser() {
            return userService.isExternalUser(self.userNetwork);
        };

        /**
         * Create or update or view a CPI
         * @param  {Object} order
         */
        self.openCPI = function openCPI(order) {
            $rootScope.order = order;
            $rootScope.cpi = order.cpi;
            $scope.goTo('/bdc/cpi');
        };

        /**
         * Publish a cpi
         * @param  {int} orderId
         */
        self.publishCPI = function publishCPI(order) {
            cpiService
                .publish(order)
                .then(function(data) {
                    Notification.success(data.message);
                })
                .catch(function(res) {
                    Notification.error(
                        'Une erreur est survenue ' + (res.data ? ': ' + res.data : '')
                    );
                    $log.error(res);
                });
        };

        /**
         * Delete a CPI
         * @param  {Object} order
         */
        self.deleteCPI = function deleteCPI(order) {
            cpiService
                .deleteCPI(order)
                .then(function(data) {
                    Notification.success(data.message);
                })
                .catch(function(res) {
                    Notification.error(
                        'Une erreur est survenue ' + (res.data ? ': ' + res.data : '')
                    );
                    $log.error(res);
                });
        };

        /**
         * Save the cmde keys
         * @param {Object} order
         */
        self.saveCmdeKeys = function saveCmdeKeys(order) {
            orderService
                .saveCmdeKeys(order)
                .then(function(res) {
                    Notification.success(res.message);
                })
                .catch(function(res) {
                    Notification.error(
                        'Une erreur est survenue ' + (res.data ? ': ' + res.data : '')
                    );
                    $log.error(res);
                });
        };

        /**
         * Togle the panel display
         */
        self.toggleOpenedPanel = function toggleOpenedPanel() {
            self.isPanelOpened = !self.isPanelOpened;
        };

        /**
         * Get the order's creator lastname and firstname to display
         * If the uid is not found into the people array, it returns the uid instead of the name
         * @param  {String} uid
         * @return {String}
         */
        self.getName = function getName(uid) {
            const user = userService.findPerson(uid);
            return user ? user.user.displayName : uid;
        };

        self.downloadOrders = function downloadOrders() {
            orderService
                .downloadOrders()
                .then(function() {
                    Notification.success('Les commandes ont été téléchargées');
                })
                .catch(function(err) {
                    Notification.error('Une erreur est survenue');
                    $log.error(err);
                });
        };

        /* =========================================================================================== */
        /*                                        FILTERS                                              */
        /* =========================================================================================== */

        var _filters = {
            rds: [],
            drv: [],
            telepro: [],
            cs: [],
            cup: [],
            formerRDS: [],
            offset: 0,
            limit: self.limit,
        };

        _initIHMFilters();

        self.isFiltered = false;

        /* Date updated filter */
        self.dateStartFilterOptions = filtersService.dateUpdatedOptions;
        self.dateEndFilterOptions = filtersService.dateUpdatedOptions;

        self.isOpenedDateStartFilter = false;
        self.isOpenedDateEndFilter = false;
        self.isOpenedCreationDateStartFilter = false;
        self.isOpenedCreationDateEndFilter = false;

        self.toggleDateStartFilter = function toggleDateStartFilter() {
            self.isOpenedDateStartFilter = filtersService.toggle(self.isOpenedDateStartFilter);
        };

        self.toggleDateEndFilter = function toggleDateEndFilter() {
            self.isOpenedDateEndFilter = filtersService.toggle(self.isOpenedDateEndFilter);
        };

        self.toggleCreationDateStartFilter = function toggleCreationDateStartFilter() {
            self.isOpenedCreationDateStartFilter = filtersService.toggle(self.isOpenedCreationDateStartFilter);
        };

        self.toggleCreationDateEndFilter = function toggleCreationDateEndFilter() {
            self.isOpenedCreationDateEndFilter = filtersService.toggle(self.isOpenedCreationDateEndFilter);
        };

        /* Month of signature filter */
        self.signatureMonthFilterOptions = filtersService.signatureMonthOptions;
        self.isOpenedSignatureMonthFilter = [false, false];

        self.toggleSignatureMonthFilter = function toggleSignatureMonthFilter(index) {
            self.isOpenedSignatureMonthFilter[index] = filtersService.toggle(self.isOpenedSignatureMonthFilter[index]);
        };

        /* Month of installation filter */
        self.installationMonthFilterOptions = filtersService.installationMonthOptions;
        self.isOpenedInstallationMonthFilter = [false, false];

        self.toggleInstallationMonthFilter = function toggleInstallationMonthFilter(index) {
            self.isOpenedInstallationMonthFilter[index] = filtersService.toggle(
                self.isOpenedInstallationMonthFilter[index]
            );
        };

        /**
         * Generate the values for the rds filter at the clear or loading action
         * @return {Array}
         */
        function _generateRDSFilter() {
            if (self.userNetwork.role === 'DRV') {
                _filters.drv = [self.userNetwork.user.uid];
                return [];
            }

            if (!self.userNetwork.drv.length && self.userNetwork.rds.length) {
                var rds = [];

                for (var i = 0; i < self.userNetwork.rds.length; i++) {
                    rds.push(self.userNetwork.rds[i].user.uid);
                }

                return rds;
            }

            return !self.userNetwork.rds.length ? [self.userNetwork.user.uid] : [];
        }

        /**
         * Apply selected filter values
         */
        self.applyFilter = function applyFilter() {
            if (!self.isFiltered) {
                _filters.offset = 0;
                self.isOtherOrders = true;
            }
            _filters.limit = self.limit;

            if (
                self.identifiantFilter !== null &&
                self.identifiantFilter !== '' &&
                !Number.isInteger(parseInt(self.identifiantFilter))
            ) {
                Notification.error("<b>Erreur sur l'identifiant:</b> ce n'est pas un nombre");
                return;
            }
            if (
                self.businessFilter !== null &&
                self.businessFilter !== '' &&
                !Number.isInteger(parseInt(self.businessFilter))
            ) {
                Notification.error("<b>Erreur sur le numéro d'affaire:</b> ce n'est pas un nombre");
                return;
            }
            if (
                self.dateEndFilter !== null &&
                commonService.checkDateRange(self.dateStartFilter, self.dateEndFilter) === false
            ) {
                Notification.error(
                    '<b>Erreur sur la période du filtre:</b> date de modification de début avant celle de fin'
                );
                return;
            }
            if (
                self.creationDateEndFilter !== null &&
                commonService.checkDateRange(self.creationDateStartFilter, self.creationDateEndFilter) === false
            ) {
                Notification.error(
                    '<b>Erreur sur la période du filtre:</b> date de création de début avant celle de fin'
                );
                return;
            }
            if (
                self.signatureMonthFilter[1] !== null &&
                commonService.checkDateRange(self.signatureMonthFilter[0], self.signatureMonthFilter[1]) === false
            ) {
                Notification.error(
                    '<b>Erreur sur la période du filtre:</b> Mois de signature de début avant celui de fin'
                );
                return;
            }
            if (
                self.installationMonthFilter[1] !== null &&
                commonService.checkDateRange(self.installationMonthFilter[0], self.installationMonthFilter[1]) === false
            ) {
                Notification.error(
                    "<b>Erreur sur la période du filtre:</b> Mois d'installation de début avant celui de fin"
                );
                return;
            }

            // Map present filters in the controller to build an array with their values
            var filtersToSave = filtersService.filtersList.map(function(key) {
                return self[key];
            });
            // Save builts array with filters values
            filtersService.saveFilters(filtersToSave);

            _filters.dateStart = filtersService.applyFullDateFilter(self.dateStartFilter);
            _filters.dateEnd = filtersService.applyFullDateFilter(self.dateEndFilter);
            _filters.creationDateStart = filtersService.applyFullDateFilter(self.creationDateStartFilter);
            _filters.creationDateEnd = filtersService.applyFullDateFilter(self.creationDateEndFilter);
            _filters.signatureMonth = self.signatureMonthFilter.map(filtersService.applyMonthDateFilter);
            _filters.installationMonth = self.installationMonthFilter.map(filtersService.applyMonthDateFilter);

            _updateOrdersList();
        };

        /**
         * Reset filters
         */
        self.clearFilters = function clearFilters() {
            filtersService.clearFilters();
            $rootScope.orders = [];
            $rootScope.business = null;
            _initIHMFilters();

            _filters.rds = _generateRDSFilter();
            _filters.drv = [];
            _filters.telepro = [];
            _filters.cs = [];
            _filters.cup = [];
            _filters.formerRDS = [];
            _filters.market = [];
            _filters.offset = 0;
            _initFiltersValues();

            var marketFilterLength = self.marketFilter.length;
            for (var i = 0; i < marketFilterLength; i++) {
                self.marketFilter[i] = false;
            }

            self.isOtherOrders = true;

            self.userNetwork.rds.forEach(function(rds) {
                rds.checked = false;
            });

            self.userNetwork.drv.forEach(function(drv) {
                drv.checked = false;
            });

            self.userNetwork.telepro.forEach(function(telepro) {
                telepro.checked = false;
            });

            self.userNetwork.cs.forEach(function(cs) {
                cs.checked = false;
            });

            self.userNetwork.cup.forEach(function(cup) {
                cup.checked = false;
            });

            self.userNetwork.formerRDS.forEach(function(formerRDS) {
                formerRDS.checked = false;
            });

            self.rdsFilter = _generateRDSFilterForIHM();

            _updateOrdersList();
        };

        /* WATCHERS SECTION: On filters arrays to construct values for the request and uncheck same filter's checkboxes */

        $scope.$watchCollection('listCtrl.statusFilter', function(newValue, oldValue) {
            if (oldValue.length === 0) {
                return;
            }
            _filters.status = filtersService.applyFilter(self.statusFilter, 'status');

            if (!oldValue[0] && newValue[0]) {
                self.statusFilter = [true, false, false];
                self.cancelledFilter = [false, false];
                self.lostFilter = [false, false];
                self.abandonedFilter = [false, false];
            }

            if (!oldValue[1] && newValue[1]) {
                self.statusFilter = [false, true, false];
                self.cancelledFilter = [false, false];
                self.lostFilter = [false, false];
                self.abandonedFilter = [false, false];
            }

            if (!oldValue[2] && newValue[2]) {
                self.statusFilter = [false, false, true];
                self.cancelledFilter = [false, false];
                self.lostFilter = [false, false];
                self.abandonedFilter = [false, false];
            }
        });

        $scope.$watchCollection('listCtrl.cancelledFilter', function(newValue, oldValue) {
            if (oldValue.length === 0) {
                return;
            }
            _filters.cancelled = filtersService.applyFilter(self.cancelledFilter, 'cancelled');

            if (!oldValue[0] && newValue[0]) {
                self.cancelledFilter = [true, false];
                self.statusFilter = [false, false, false];
                self.lostFilter = [false, false];
                self.abandonedFilter = [false, false];
            }

            if (!oldValue[1] && newValue[1]) {
                self.cancelledFilter = [false, true];
                self.statusFilter = [false, false, false];
                self.lostFilter = [false, false];
                self.abandonedFilter = [false, false];
            }
        });

        $scope.$watchCollection('listCtrl.lostFilter', function(newValue, oldValue) {
            if (oldValue.length === 0) {
                return;
            }
            _filters.lost = filtersService.applyFilter(self.lostFilter, 'lost');

            if (!oldValue[0] && newValue[0]) {
                self.statusFilter = [false, false, false];
                self.cancelledFilter = [false, false];
                self.lostFilter = [true, false];
                self.abandonedFilter = [false, false];
            }

            if (!oldValue[1] && newValue[1]) {
                self.statusFilter = [false, false, false];
                self.cancelledFilter = [false, false];
                self.lostFilter = [false, true];
                self.abandonedFilter = [false, false];
            }
        });

        $scope.$watchCollection('listCtrl.abandonedFilter', function(newValue, oldValue) {
            if (oldValue.length === 0) {
                return;
            }
            _filters.abandoned = filtersService.applyFilter(self.abandonedFilter, 'abandoned');

            if (!oldValue[0] && newValue[0]) {
                self.statusFilter = [false, false, false];
                self.cancelledFilter = [false, false];
                self.lostFilter = [false, false];
                self.abandonedFilter = [true, false];
            }

            if (!oldValue[1] && newValue[1]) {
                self.statusFilter = [false, false, false];
                self.cancelledFilter = [false, false];
                self.lostFilter = [false, false];
                self.abandonedFilter = [false, true];
            }
        });

        $scope.$watchCollection('listCtrl.cpiReleasedFilter', function(newValue, oldValue) {
            if (oldValue.length === 0) {
                return;
            }
            _filters.cpiReleased = filtersService.applyFilter(self.cpiReleasedFilter, 'cpiReleased');

            if (!oldValue[0] && newValue[0]) {
                self.cpiReleasedFilter = [true, false];
                self.cpiNotCreatedFilter = [false];
            }

            if (!oldValue[1] && newValue[1]) {
                self.cpiReleasedFilter = [false, true];
                self.cpiNotCreatedFilter = [false];
            }
        });

        $scope.$watchCollection('listCtrl.cpiNotCreatedFilter', function(newValue, oldValue) {
            if (oldValue.length === 0) {
                return;
            }
            _filters.cpiNotCreated = filtersService.applyFilter(self.cpiNotCreatedFilter, 'cpiNotCreated');

            if (!oldValue[0] && newValue[0]) {
                self.cpiReleasedFilter = [false, false];
                self.cpiNotCreatedFilter = [true];
            }
        });

        $scope.$watchCollection('listCtrl.jdsInjectedFilter', function(newValue, oldValue) {
            if (oldValue.length === 0) {
                return;
            }
            _filters.jdsInjected = filtersService.applyFilter(self.jdsInjectedFilter, 'jdsInjected');

            if (!oldValue[0] && newValue[0]) {
                self.jdsInjectedFilter = [true, false];
            }

            if (!oldValue[1] && newValue[1]) {
                self.jdsInjectedFilter = [false, true];
            }
        });

        $scope.$watchCollection('listCtrl.cmdeKeyFilter', function(newValue, oldValue) {
            if (oldValue.length === 0) {
                return;
            }
            _filters.cmdeKey = filtersService.applyFilter(self.cmdeKeyFilter, 'cmdeKey');

            if (!oldValue[0] && newValue[0]) {
                self.cmdeKeyFilter = [true, false];
            }

            if (!oldValue[1] && newValue[1]) {
                self.cmdeKeyFilter = [false, true];
            }
        });

        $scope.$watchCollection('listCtrl.offerTypeFilter', function(newValue, oldValue) {
            if (oldValue.length === 0) {
                return;
            }
            _filters.offerType = filtersService.applyFilter(self.offerTypeFilter, 'offerType');

            if (!oldValue[0] && newValue[0]) {
                self.offerTypeFilter = [true, false];
            }

            if (!oldValue[1] && newValue[1]) {
                self.offerTypeFilter = [false, true];
            }
        });

        $scope.$watchCollection('listCtrl.networkFilter', function(newValue, oldValue) {
            if (oldValue.length === 0) {
                return;
            }
            _filters.network = filtersService.applyFilter(self.networkFilter, 'network');

            if (!oldValue[0] && newValue[0]) {
                self.networkFilter = [true, false, false];
            }

            if (!oldValue[1] && newValue[1]) {
                self.networkFilter = [false, true, false];
            }

            if (!oldValue[2] && newValue[2]) {
                self.networkFilter = [false, false, true];
            }
        });

        $scope.$watchCollection('listCtrl.orderScenarioFilter', function(newValue, oldValue) {
            if (oldValue.length === 0) {
                return;
            }
            _filters.orderScenario = filtersService.applyMultipleFilterValues(
                self.orderScenarioFilter,
                'orderScenario'
            );

            if (!oldValue[0] && !oldValue[1] && !oldValue[2] && !oldValue[4]
                && (newValue[0] || newValue[1] || newValue[2] || newValue[4])) {
                newValue[3] = false;
            }

            if (!oldValue[3] && newValue[3]) {
                newValue[0] = false;
                newValue[1] = false;
                newValue[2] = false;
                newValue[4] = false;
            }
            self.orderScenarioFilter = newValue;
        });

        $scope.$watch('listCtrl.clientFilter', function(newValue, oldValue) {
            if (oldValue === '') {
                return;
            }
            _filters.client = null;

            if (newValue !== '') {
                _filters.client = newValue;
            }
        });

        $scope.$watch('listCtrl.identifiantFilter', function(newValue, oldValue) {
            if (oldValue === '') {
                return;
            }
            _filters.identifiant = null;

            if (newValue !== '') {
                _filters.identifiant = newValue;
            }
        });

        $scope.$watch('listCtrl.businessFilter', function(newValue, oldValue) {
            if (oldValue === '') {
                return;
            }
            _filters.businessId = null;

            if (newValue !== '') {
                _filters.businessId = newValue;
            }
        });

        function _generateMarketFilterForIHM(markets) {
            return filtersService.getDefaultFilter('boolean', markets.length);
        }

        function _generateNetworkFilterForIHM(orderTypes) {
            return filtersService.getDefaultFilter('boolean', orderTypes.length);
        }

        function _generateScenarioFilterForIHM(scenarioTypes) {
            return filtersService.getDefaultFilter('boolean', scenarioTypes.length);
        }

        /**
         * Generate the RDS filter options list
         * @param  {Array} parents
         * @return {Array}
         */
        function _generateRDSFilterForIHM(parents) {
            if (!parents || !parents.length) {
                return self.userNetwork.rds;
            }

            var rds = [];
            for (var i = 0; i < parents.length; i++) {
                for (var j = 0; j < self.userNetwork.rds.length; j++) {
                    if (parents[i].user.uid === self.userNetwork.rds[j].parent) {
                        rds.push(self.userNetwork.rds[j]);
                    }
                }
            }
            return rds;
        }

        /**
         * Watch drv filter input to construct filter value
         */
        self.updateDRVFilter = function updateDRVFilter() {
            var selectedDRV = $filter('filter')(self.userNetwork.drv, { checked: true });
            _filters.drv = [];
            var parents = [];

            for (var i = 0; i < selectedDRV.length; i++) {
                _filters.drv.push(selectedDRV[i].user.uid);
                parents.push(selectedDRV[i]);
            }

            self.rdsFilter = _generateRDSFilterForIHM(parents);
        };

        /**
         * Watch rds filter input to construct filter value
         */
        self.updateRDSFilter = function updateRDSFilter() {
            var selectedRDS = $filter('filter')(self.userNetwork.rds, { checked: true });
            _filters.rds = [];

            for (var i = 0; i < selectedRDS.length; i++) {
                _filters.rds.push(selectedRDS[i].user.uid);
            }
        };

        self.updateTeleproFilter = function updateTeleproFilter() {
            var selectedTelepro = $filter('filter')(self.userNetwork.telepro, { checked: true });
            _filters.telepro = [];

            for (var i = 0; i < selectedTelepro.length; i++) {
                _filters.telepro.push(selectedTelepro[i].user.uid);
            }
        };

        self.updateCsFilter = function updateCsFilter() {
            var selectedCs = $filter('filter')(self.userNetwork.cs, { checked: true });
            _filters.cs = [];

            for (var i = 0; i < selectedCs.length; i++) {
                _filters.cs.push(selectedCs[i].user.uid);
            }
        };

        self.updateCUPFilter = function updateCUPFilter() {
            var selectedCup = $filter('filter')(self.userNetwork.cup, { checked: true });
            _filters.cup = [];

            for (var i = 0; i < selectedCup.length; i++) {
                _filters.cup.push(selectedCup[i].user.uid);
            }
        };

        self.updateFormerRDSFilter = function updateFormerRDSFilter() {
            var selectedRDS = $filter('filter')(self.userNetwork.formerRDS, { checked: true });
            _filters.formerRDS = [];

            for (var i = 0; i < selectedRDS.length; i++) {
                _filters.formerRDS.push(selectedRDS[i].user.uid);
            }
        };

        /**
         *  update filters.market with id from marketsList according to checked filters
         */
        function _updateMarketFilter() {
            var marketCodes = self.marketsList.map(function(market) {
                // get code
                return market.code;
            });
            _filters.market = filtersService.applyMultipleFilterValues(self.marketFilter, marketCodes);
        }
        self.updateMarketFilter = _updateMarketFilter;

        /**
         * Apply default filters Values to IHM
         */
        function _initIHMFilters() {
            if (filtersService.saved) {
                filtersService.filtersList.forEach(function(key, index) {
                    self[key] = filtersService.getFilters()[index]; // assign saved filter values
                });
            }
            else {
                self.statusFilter = filtersService.getDefaultFilter('boolean', 3);
                self.networkFilter = filtersService.getDefaultFilter('boolean', 3);
                self.offerTypeFilter = filtersService.getDefaultFilter('boolean', 2);
                self.cancelledFilter = filtersService.getDefaultFilter('boolean', 2);
                self.lostFilter = filtersService.getDefaultFilter('boolean', 2);
                self.abandonedFilter = filtersService.getDefaultFilter('boolean', 2);
                self.cpiNotCreatedFilter = filtersService.getDefaultFilter('boolean', 1);
                self.cpiReleasedFilter = filtersService.getDefaultFilter('boolean', 2);
                self.jdsInjectedFilter = filtersService.getDefaultFilter('boolean', 2);
                self.cmdeKeyFilter = filtersService.getDefaultFilter('boolean', 2);
                self.orderScenarioFilter = filtersService.getDefaultFilter('boolean', 4);
                self.identifiantFilter = filtersService.getDefaultFilter('integer');
                self.businessFilter = $rootScope.business || filtersService.getDefaultFilter('integer');
                self.clientFilter = filtersService.getDefaultFilter('string');
                self.dateStartFilter = filtersService.getDefaultFilter('date');
                self.dateEndFilter = filtersService.getDefaultFilter('date');
                self.creationDateStartFilter = filtersService.getDefaultFilter('date');
                self.creationDateEndFilter = filtersService.getDefaultFilter('date');
                self.signatureMonthFilter = filtersService.getDefaultFilter('dateInterval', 2);
                self.installationMonthFilter = filtersService.getDefaultFilter('dateInterval', 2);
            }
        }

        function _initFiltersValues() {
            _filters.identifiant = self.identifiantFilter;
            _filters.businessId = self.businessFilter;
            _filters.status = filtersService.applyFilter(self.statusFilter, 'status');
            _filters.cancelled = filtersService.applyFilter(self.cancelledFilter, 'cancelled');
            _filters.lost = filtersService.applyFilter(self.lostFilter, 'lost');
            _filters.abandoned = filtersService.applyFilter(self.abandonedFilter, 'abandoned');
            _filters.network = filtersService.applyFilter(self.networkFilter, 'network');
            _filters.offerType = filtersService.applyFilter(self.offerTypeFilter, 'offerType');
            _filters.dateStart = filtersService.applyFullDateFilter(self.dateStartFilter);
            _filters.dateEnd = filtersService.applyFullDateFilter(self.dateEndFilter);
            _filters.creationDateStart = filtersService.applyFullDateFilter(self.creationDateStartFilter);
            _filters.creationDateEnd = filtersService.applyFullDateFilter(self.creationDateEndFilter);
            _filters.signatureMonth = self.signatureMonthFilter.map(filtersService.applyMonthDateFilter);
            _filters.installationMonth = self.installationMonthFilter.map(filtersService.applyMonthDateFilter);
            _filters.client = self.clientFilter;
            _filters.cpiNotCreated = filtersService.applyFilter(self.cpiNotCreatedFilter, 'cpiNotCreated');
            _filters.cpiReleased = filtersService.applyFilter(self.cpiReleasedFilter, 'cpiReleased');
            _filters.jdsInjected = filtersService.applyFilter(self.jdsInjectedFilter, 'jdsInjected');
            _filters.cmdeKey = filtersService.applyFilter(self.cmdeKeyFilter, 'cmdeKey');
            _filters.orderScenario = filtersService.applyMultipleFilterValues(
                self.orderScenarioFilter,
                'orderScenario'
            );
        }

        /* =========================================================================================== */
        /*                                         JDS                                                 */
        /* =========================================================================================== */

        self.jdsLoading = false;

        /**
         * Set the order isJdsInjected attribute to
         * @method setJdsInjected
         * @param  {Object} order
         * @param  {Boolean} value isJdsInjected value
         */
        self.setJdsInjected = function setJdsInjected(order, value) {
            order.isJdsInjected = value;
            orderService
                .setJdsInjected(order, value)
                .then(function(res) {
                    Notification.success(res.message);
                })
                .catch(function(res) {
                    Notification.error(
                        'Une erreur est survenue ' + (res.data ? ': ' + res.data : '')
                    );
                    $log.error(res);
                });
        };

        /**
         * Open JDS report with specific orders
         * @param  {String} type order type, used to adapt jds
         * @param  {String} order market, used to adapt jds
         * @param  {String} order offer type, used to adapt jds
         * @return {Promise} promise returned from orderService.getOrders
         */
        self.loadJds = function loadJds() {
            self.jdsLoading = true;
            // self.exportJdsTrad = false;

            // Set date filters values
            _filters.dateStart = filtersService.applyFullDateFilter(self.dateStartFilter);
            _filters.dateEnd = filtersService.applyFullDateFilter(self.dateEndFilter);
            _filters.creationDateStart = filtersService.applyFullDateFilter(self.creationDateStartFilter);
            _filters.creationDateEnd = filtersService.applyFullDateFilter(self.creationDateEndFilter);
            _filters.signatureMonth = self.signatureMonthFilter.map(filtersService.applyMonthDateFilter);
            _filters.installationMonth = self.installationMonthFilter.map(filtersService.applyMonthDateFilter);

            // We set the specific filters depending on the selected JDS export
            // If the type is TRAD, we send a specific filter : isExportJdsTrad, otherwise it's NAP
            // if (type === 'TRAD') {
            //     _filters.isExportJdsTrad = true;
            //     self.exportJdsTrad = true;
            //     // type = null;
            // }
            // else {
            //     _filters.network = 'NAP';
            // }

            return orderService.getOrders(filtersService.getJdsFilters(_filters)).then(function(orders) {
                for (let order of orders) {
                    let orderFormCopy = JSON.parse(JSON.stringify($rootScope.orderForm));
                    $rootScope.orderDiscounts = orderService.updateDiscountValues(order.options);
                    // // We filter all options and cashDrawers prices according to the validityDate of the offer
                    orderFormCopy.options.map(function (option) {
                        option.prices = orderService.filterOptionPrices(option, order);
                    });

                    orderFormCopy.cashDrawers.map(function (drawer) {
                        drawer.prices = orderService.filterOptionPrices(drawer, order);
                    });

                    orderFormCopy.tillPrices.map(till =>{
                        till.prices = orderService.filterTillPrices(till, order);
                    });
                    // Init the offer
                    if (typeof order.offer === 'undefined') {
                        order.offer = self.orderForm.offers[0];
                    }

                    // Init Package
                    if (typeof order.package === 'undefined') {
                        order.package = {};
                    }

                    goodwillGesturesService.setOrderForm(orderFormCopy);
                    pricesService.setOrderForm(orderFormCopy);
                    pricesService.setOrder(order);
                    unitBonusService.setOrder(order);
                }
                self.jdsLoading = false;
                reportRoutingService.openReport('JDS', orders, null, null);
            }).catch(err => {
                Notification.error('Une erreur est survenue ' + err)
                $log.error(err)
            })
                .finally(()=> self.jdsLoading = false);
        };

        self.loadExportLaddition = function loadExportLaddition() {
            self.jdsLoading = true;

            // Set date filters values
            _filters.dateStart = filtersService.applyFullDateFilter(self.dateStartFilter);
            _filters.dateEnd = filtersService.applyFullDateFilter(self.dateEndFilter);
            _filters.creationDateStart = filtersService.applyFullDateFilter(self.creationDateStartFilter);
            _filters.creationDateEnd = filtersService.applyFullDateFilter(self.creationDateEndFilter);
            _filters.signatureMonth = self.signatureMonthFilter.map(filtersService.applyMonthDateFilter);
            _filters.installationMonth = self.installationMonthFilter.map(filtersService.applyMonthDateFilter);

            _filters.market = ['LADDITION'];

            return orderService.getOrders(filtersService.getJdsFilters(_filters)).then(function(orders) {
                self.jdsLoading = false;
                reportRoutingService.openReport('EXPORTLADDITION', orders);
            });
        };

        self.loadExportWebTill = function loadExportWebTill() {
            self.jdsLoading = true;

            // Set date filters values
            _filters.dateStart = filtersService.applyFullDateFilter(self.dateStartFilter);
            _filters.dateEnd = filtersService.applyFullDateFilter(self.dateEndFilter);
            _filters.creationDateStart = filtersService.applyFullDateFilter(self.creationDateStartFilter);
            _filters.creationDateEnd = filtersService.applyFullDateFilter(self.creationDateEndFilter);
            _filters.signatureMonth = self.signatureMonthFilter.map(filtersService.applyMonthDateFilter);
            _filters.installationMonth = self.installationMonthFilter.map(filtersService.applyMonthDateFilter);

            _filters.market = ['FLEURISTE'];
            _filters.offerType = ['webTill'];

            return orderService.getOrders(filtersService.getJdsFilters(_filters)).then(function(orders) {
                self.jdsLoading = false;
                reportRoutingService.openReport('EXPORTWEBTILL', orders);
            });

        };

        /* =========================================================================================== */
        /*                                         MODALS                                              */
        /* =========================================================================================== */

        /**
         * Open the order creation modal : first step
         * @param  {String} size
         */
        self.openModalFirstStep = function(size) {
            var _firstStepModal = $uibModal.open({
                animation: true,
                templateUrl: 'firstStepModal.html',
                controller: 'CreateBDCFirstStepCtrl',
                controllerAs: 'createBDCFirstStepCtrl',
                size: size,
                resolve: {}
            });

            _firstStepModal.result.then(function(res) {
                $rootScope.order.orderType = res.orderType;
                $rootScope.order.marketType = res.orderMarket;

                // Mudetaf is never used for FLEURISTE
                if (res.orderMarket === 'FLEURISTE') {
                    $rootScope.order.contract.isMudetaf = false;
                }

                if (!res.client) {
                    return self.openModalSecondStep();
                }

                $rootScope.order.client = res.client;
                self.openModalSecondStep();
            });
        };

        /**
         * Open the order creation modal : second step
         * @param  {String} size
         */
        self.openModalSecondStep = function(size) {
            var _secondStepModal = $uibModal.open({
                animation: true,
                templateUrl: 'createUpdateClient.html', // modal client.html
                controller: 'CreateUpdateClientCtrl',
                controllerAs: 'createUpdateClientCtrl',
                size: size,
                resolve: {
                    order: function() {
                        return $rootScope.order;
                    }
                }
            });

            _secondStepModal.result.then(function() {
                _goToOrderForm();
            });
        };

        /**
         * Go to the order form
         */
        function _goToOrderForm() {
            $scope.goTo('/bdc/order');
        }

        /**
         * Open the delete order modal
         * @param  {String} size
         */
        function _openModalDeleteOrder(size) {
            var deleteOrderModal = $uibModal.open({
                animation: true,
                templateUrl: 'deleteOrderModal.html',
                controller: 'DeleteOrderCtrl',
                controllerAs: 'deleteOrderCtrl',
                size: size,
                resolve: {}
            });

            deleteOrderModal.result.then(function(isConfirm) {
                if (isConfirm) {
                    _confirmDelete();
                }
            });
        }

        /**
         * Open the sign order modal
         * @param  {String} size
         */
        function _openModalSignOrder(size) {
            var _secondStepModal = $uibModal.open({
                animation: true,
                templateUrl: 'signOrder.html',
                controller: 'SignOrderCtrl',
                controllerAs: 'signOrderCtrl',
                size: size,
                resolve: {
                    order: function() {
                        return self.orders.find(order => order.id === self.orderToSign);
                    }
                }
            });

            _secondStepModal.result.then(function(data) {
                _confirmSign(data);
            });
        }

        /**
         * Open the sign order modal
         * @param id
         * @param  {String} size
         */
        self.openModalSponsor = (id, size) =>{
            const sponsorModal = $uibModal.open({
                animation: true,
                templateUrl: 'sponsor.html',
                controller: 'SponsorOrderCtrl',
                controllerAs: 'signOrderCtrl',
                size: size,
                resolve: {
                    order: function() {
                        return self.orders.find(order => order.id === id);
                    }
                }
            });

            sponsorModal.result.then(function(data) {
                _saveSponsor(data);
            });
        }

        let _saveSponsor = (data) => {
            orderService.saveSponsor(data).then(function(res) {
                if(res)
                    Notification.success('Parrain enregistré avec succès');
            }).catch(function(err) {
                Notification.error(
                    'Erreur lors de l\'enregistrement du sponsor: ' + err.data
                );
            });
        }

        /**
         * Open the cancel or replace modal
         */
        self.openModalCancelOrReplace = function openModalCancelOrReplace(order) {
            var modal = $uibModal.open({
                animation: true,
                templateUrl: 'cancelOrReplaceModal.html',
                controller: 'CancelOrReplaceCtrl',
                controllerAs: 'cancelOrReplaceCtrl',
                size: 'lg',
                resolve: {
                    order: function() {
                        return order;
                    }
                }
            });

            modal.result.then(function(newOrder) {
                if (newOrder) {
                    self.orders.splice(0, 0, newOrder);
                }
            });
        };

        function _openModalLoseOrder(size) {
            var modal = $uibModal.open({
                animation: true,
                templateUrl: 'loseOrder.html',
                controller: 'LoseOrderCtrl',
                controllerAs: 'loseOrderCtrl',
                size: size,
                resolve: {}
            });
            modal.result.then(function(isLost) {
                if (isLost === true) {
                    for (var i = 0; i < self.orders.length; i++) {
                        if (self.orders[i].id === self.orderToLose) {
                            self.orders[i].isLost = true;
                            self.orders[i].dateLost = moment().format('YYYY-MM-DD');

                            orderService
                                .loseOrder(self.orders[i])
                                .then(function(res) {
                                    Notification.success(res);
                                })
                                .catch(function(err) {
                                    Notification.error(
                                        "Erreur lors de l'attribution du statut perdu: " + err.data
                                    );
                                    $log.error(err);
                                });
                            break;
                        }
                    }
                }
            });
        }

        function _openModalAbandonedOrder(size) {
            var modal = $uibModal.open({
                animation: true,
                templateUrl: 'abandonedOrder.html',
                controller: 'AbandonedOrderCtrl',
                controllerAs: 'abandonedOrderCtrl',
                size: size,
                resolve: {}
            });
            modal.result.then(function(isAbandoned) {
                if (isAbandoned === true) {
                    for (var i = 0; i < self.orders.length; i++) {
                        if (self.orders[i].id === self.orderToAbandoned) {
                            self.orders[i].isAbandoned = true;
                            self.orders[i].dateAbandonment = moment().format('YYYY-MM-DD');

                            orderService
                                .abandonedOrder(self.orders[i])
                                .then(function(res) {
                                    Notification.success(res);
                                })
                                .catch(function(err) {
                                    Notification.error(
                                        "Erreur lors de l'attribution du statut abandonné: " + err.data
                                    );
                                    $log.error(err);
                                });
                            break;
                        }
                    }
                }
            });
        }

        function _openModalRollbackDateCreated(size) {
            var modal = $uibModal.open({
                animation: true,
                templateUrl: 'rollbackDateCreated.html',
                controller: 'RollbackDateCreatedCtrl',
                controllerAs: 'rollbackDateCreatedCtrl',
                size: size,
                resolve: {}
            });
            modal.result.then(function(isRollback) {
                if (isRollback === true) {
                    for (let i = 0; i < self.orders.length; i++) {
                        if (self.orders[i].id === self.orderToRollback) {
                            orderService
                                .rollbackDateCreated(self.orders[i])
                                .then(function(res) {
                                    self.orders[i] = res
                                    Notification.success('Date de création modifiée avec succès au ' + moment(res.dateCreated).format('DD/MM/YYYY') );
                                })
                                .catch(function(err) {
                                    Notification.error(
                                        "Erreur lors du changement de date de création: " + err.data.message
                                    );
                                    $log.error(err);
                                });
                            break;
                        }
                    }
                }
            });
        }

        function _openModalSetOrderReadyForX3Integration(order) {
            var modal = $uibModal.open({
                animation: true,
                templateUrl: 'setOrderReadyForX3Integration.html',
                controller: 'SetOrderReadyForX3IntegrationCtrl',
                controllerAs: 'setOrderReadyForX3IntegrationCtrl',
                size: 'lg',
                resolve: { order }
            });
            modal.result.then(function(isReadyForX3Integration) {
                if (isReadyForX3Integration === true) {
                    for (var i = 0; i < self.orders.length; i++) {
                        if (self.orders[i].id === self.orderToSetReadyForX3Integration) {
                            self.orders[i].isReadyForX3Integration = true;
                            orderService.setRealDateSignature(self.orders[i]).then(function(res){
                                Notification.success(res);
                            }).catch(function(err) {
                                Notification.error(
                                    'Erreur lors de l\'enregistrement de la date de signature : ' +
                                    err.data
                                );
                                $log.error(err);
                            });
                            orderService
                                .setOrderReadyForX3Integration(self.orders[i])
                                .then(function(res) {
                                    Notification.success(res);
                                })
                                .catch(function(err) {
                                    Notification.error(
                                        'Erreur lors de l\'attribution du statut "Prêt pour intégration dans X3" : ' +
                                        err.data
                                    );
                                    $log.error(err);
                                });

                            break;
                        }
                    }
                }
            });
        }
        /**
         * Open the jdp modal
         */
        self.openModalJdp = function () {
            var modal = $uibModal.open({
                animation: true,
                templateUrl: 'jdpOrder.html',
                controller: 'JdpOrderCtrl',
                controllerAs: 'jdpOrderCtrl',
                size: 'lg'
            });

            modal.result.then(function(data) {
                if (data) {
                    return orderService.getJdpOrders(moment(data.startDate).format('YYYY-MM-DD'), moment(data.endDate).format('YYYY-MM-DD'))
                        .then(function(jdp) {
                        const url = URL.createObjectURL(jdp.data);
                        let a = document.createElement('a');
                        a.href = url;
                        a.download = 'jdp.csv';
                        a.click();
                        URL.revokeObjectURL(url);
                        return jdp;
                    });
                }
            });
        };


        /* =========================================================================================== */
        /*                                        EVENTS                                               */
        /* =========================================================================================== */

        $scope.$on('online', function() {
            self.clearFilters();
        });

        $scope.$on('offline', function() {
            self.clearFilters();
        });

        $scope.$on('synchro-off', function() {
            self.clearFilters();
        });

        /* =========================================================================================== */
        /*                                         INIT                                                */

        /* =========================================================================================== */
        /**
         * Init the order list
         * 1) Get the user network
         * 2) Init the filters
         * 3) Get the orders
         */
        function _init() {
            self.userNetwork = $rootScope.userNetwork;
            self.user = $rootScope.user;
            _filters.rds = _generateRDSFilter();
            self.rdsFilter = _generateRDSFilterForIHM();
            if (self.userNetwork.rds && self.userNetwork.rds.length) {
                self.rdsFilter = self.userNetwork.rds;
            }
            if (self.userNetwork.telepro && self.userNetwork.telepro.length) {
                self.teleproFilter = self.userNetwork.telepro;
            }
            if (self.userNetwork.cs && self.userNetwork.cs.length) {
                self.csFilter = self.userNetwork.cs;
            }
            if (self.userNetwork.drv && self.userNetwork.drv.length) {
                self.drvFilter = self.userNetwork.drv;
            }
            if (self.userNetwork.cup && self.userNetwork.cup.length) {
                self.cupFilter = self.userNetwork.cup;
            }
            if (self.userNetwork.formerRDS && self.userNetwork.formerRDS.length) {
                self.formerRDSFilter = self.userNetwork.formerRDS;
            }
            $rootScope.orderDiscounts = [];
            $rootScope.order = orderService.getOrderObject();
            // Init order to create
            $rootScope.order.RDSRef = self.userNetwork.user.uid;
            $rootScope.order.DRVRef = self.userNetwork.user.parent
                ? self.userNetwork.user.parent.uid
                : self.userNetwork.user.parent;

            return orderFormService
                .getOrderForm()
                .then(function(orderForm) {
                    $rootScope.orderForm = orderForm;
                    self.offerTypeList = orderForm.offers;

                    _initServicesData(orderForm);
                    _initFiltersValues();

                    self.marketsList = self.marketService.getMarkets();
                    self.marketFilter = _generateMarketFilterForIHM(self.marketsList);
                    _updateMarketFilter();

                    self.networkList = self.orderTypeService.getOrderTypes();
                    self.networkFilter = _generateNetworkFilterForIHM(self.networkList);

                    self.scenarioTypeList = self.scenarioTypeService.getScenarioTypes();
                    self.orderScenarioFilter = _generateScenarioFilterForIHM(self.scenarioTypeList);
                })
                .then(function() {
                    self.loadingOrders = true;
                    if(!$rootScope.orders || ($rootScope.orders && $rootScope.orders.length === 0)) {
                        return orderService.getOrders(_filters).then(function (orders) {
                            self.orders = orders;

                            if (orders.length < _filters.limit) {
                                self.isOtherOrders = false;
                            }
                        });
                    }else {
                        self.orders = $rootScope.orders;
                    }
                })
                .catch(function(err) {
                    $log.error(err);
                    self.userNetwork = null;
                    self.orders = [];
                })
                .finally(function() {
                    self.loadingOrders = false;
                });
        }

        function _initServicesData(orderForm) {
            self.marketService.initMarkets(orderForm);
            self.orderTypeService.initOrderTypes(orderForm);
            self.contractTypeService.initContractTypes(orderForm);
            self.scenarioTypeService.initScenarioTypes(orderForm);
            self.storeTypeService.initStoreTypes(orderForm);
            filtersService.initFiltersValues();
        }

        _init();

        return self;
    }

    ListCtrl.$inject = [
        '$scope',
        '$window',
        '$location',
        '$timeout',
        'userNetworkService',
        'orderService',
        '$log',
        '$filter',
        'clientService',
        'orderFormService',
        '$rootScope',
        'Notification',
        'reportRoutingService',
        '$uibModal',
        'cpiService',
        'marketService',
        'userService',
        'filtersService',
        'commonService',
        'emailService',
        'orderTypeService',
        'contractTypeService',
        'scenarioTypeService',
        'storeTypeService',
        'x3IntegrationStatusService',
        'authService',
        'pricesService',
        'unitBonusService',
        'goodwillGesturesService'
    ];

    angular.module('app.bdc.list.listCtrl', ['ui.bootstrap', 'ui-notification']).controller('ListCtrl', ListCtrl);
});
